// ── Design tokeny Rankio ───────────────────────────────────────────────────────
export const theme = {
  // barvy
  blue:      "#126DFB",   // primární akce, aktivní stav
  blueDark:  "#0d5ce0",   // hover
  blueSoft:  "#E6EFFF",   // světlé bloky, aktivní pozadí
  blueLine:  "#c9d9ff",   // okraje světlých bloků
  ink:       "#0f172a",   // hlavní text / navy
  inkSoft:   "#475069",   // sekundární text
  mut:       "#8b93a7",   // muted
  line:      "#e9edf4",   // jemné linky
  bg:        "#ffffff",
  bgSoft:    "#f6f8fc",   // pozadí appky
  ok:        "#16a34a",   // pozitivní (dobrá pozice, zlepšení)
  okSoft:    "#f0fdf4",
  okLine:    "#bbf7d0",
  bad:       "#dc2626",   // negativní (pokles)
  badSoft:   "#fef2f2",
  badLine:   "#fecaca",
  // typografie — jeden font pro všechno, čísla se srovnávají tabular-nums
  font:      "'Geist', sans-serif",
  tnum:      "tabular-nums",   // font-variant-numeric pro čísla (místo monospace)
  // rádiusy — jediný zdroj pravdy jsou CSS proměnné v index.css
  rBtn:  "var(--rk-r-btn)",    // tlačítka: 32px
  rCard: "var(--rk-r-card)",   // karty a panely: 20px
  rTile: "var(--rk-r-tile)",   // číselné dlaždice: 16px
  // stíny
  shadowSm: "0 1px 3px rgba(16,24,40,.06)",
  shadowMd: "0 12px 30px -12px rgba(16,24,40,.14)",
};

export default theme;
